import { createRouter, createWebHistory } from 'vue-router'

// Commerçant
import Login         from '../views/Login.vue'
import Dashboard     from '../views/Dashboard.vue'
import Scanner       from '../views/Scanner.vue'
import NouveauClient from '../views/NouveauClient.vue'
import Cloture       from '../views/Cloture.vue'
import Parametres    from '../views/Parametres.vue'
import Historique    from '../views/Historique.vue'
import Journees      from '../views/Journees.vue'
import Stats         from '../views/Stats.vue'
import Planning      from '../views/Planning.vue'
import CarteDigitale from '../views/CarteDigitale.vue'
import CartePublique from '../views/CartePublique.vue'

// Admin
import AdminLogin       from '../views/admin/AdminLogin.vue'
import AdminDashboard   from '../views/admin/AdminDashboard.vue'
import AdminCommercants from '../views/admin/AdminCommercants.vue'
import AdminClients     from '../views/admin/AdminClients.vue'
import AdminCartes      from '../views/admin/AdminCartes.vue'
import AdminJournees    from '../views/admin/AdminJournees.vue'
import AdminSQL         from '../views/admin/AdminSQL.vue'

const routes = [
    { path: '/',               redirect: '/dashboard' },
    { path: '/login',          component: Login,         meta: { public: true } },
    { path: '/dashboard',      component: Dashboard },
    { path: '/scanner',        component: Scanner },
    { path: '/nouveau-client', component: NouveauClient },
    { path: '/cloture',        component: Cloture },
    { path: '/parametres',     component: Parametres },
    { path: '/historique',     component: Historique },
    { path: '/journees',       component: Journees },
    { path: '/stats',          component: Stats },
    { path: '/planning',       component: Planning },
    { path: '/carte/:token',   component: CartePublique, meta: { public: true } },
    { path: '/carte-digitale-demo', component: CarteDigitale, meta: { public: true } },

    { path: '/admin',               component: AdminLogin,       meta: { public: true, admin: true } },
    { path: '/admin/dashboard',     component: AdminDashboard,   meta: { admin: true } },
    { path: '/admin/commercants',   component: AdminCommercants, meta: { admin: true } },
    { path: '/admin/clients',       component: AdminClients,     meta: { admin: true } },
    { path: '/admin/cartes',        component: AdminCartes,      meta: { admin: true } },
    { path: '/admin/journees',      component: AdminJournees,    meta: { admin: true } },
    { path: '/admin/sql',           component: AdminSQL,         meta: { admin: true } },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.admin && !to.meta.public) {
        const adminToken = localStorage.getItem('admin_token')
        if (!adminToken) return next('/admin')
    }
    if (!to.meta.public && !to.meta.admin) {
        const token = localStorage.getItem('token')
        if (!token) return next('/login')
    }
    next()
})

export default router
